import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { InstiService } from '../../../insti/insti.service';
import { instiRoutehandle } from '../../../insti/instiRoutehandle.module';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent {
  public config: PerfectScrollbarConfigInterface = {};

  constructor(
   protected service?:InstiService,
   private router?: Router
     ) {
 
  } 
    

  getUserName(){
    let user = this.service.getUserData();

    if(!user || user == null || user === null){  
      this.router.navigate([this.service.getLoginUrl()]);
      return '';
    }

    let nome_completo = user['nome'];
    let nomes = nome_completo.split(' ');
    
    if(nomes.length == 1){
      return nomes[0];
    }

    let nome_primeiro_ultimo = nomes[0] + ' ' + nomes[nomes.length - 1];

    return nome_primeiro_ultimo;
  }

  getUserType(){
    let user = this.service.getUserData();

    if(!user || user == null || user === null){  
      this.router.navigate([this.service.getLoginUrl()]);
      return '';
    }

    switch (user['tipo_user']) {
      case '1':
        return 'Desenvolvedor';
      case '2':        
      return 'Administrador';
      case '3':
        return 'Técnico';      
      case '4':
        return 'Comum';
      default:
        return '';
    }
  }

  // This is for Notifications
  notifications: Object[] = [
    {
      round: 'round-danger',
      icon: 'ti-link',
      title: 'Launch Admin',
      subject: 'Just see the my new admin!',
      time: '9:30 AM'
    },
    {
      round: 'round-success',
      icon: 'ti-calendar',
      title: 'Event today',
      subject: 'Just a reminder that you have event',
      time: '9:10 AM'
    },
    {
      round: 'round-info',
      icon: 'ti-settings',
      title: 'Settings',
      subject: 'You can customize this template as you want',
      time: '9:08 AM'
    },
    {
      round: 'round-primary',
      icon: 'ti-user',
      title: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: './assets/images/users/1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM'
    },
    {
      useravatar: './assets/images/users/2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung a song! See you at',
      time: '9:10 AM'
    },
    {
      useravatar: './assets/images/users/2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am a singer!',
      time: '9:08 AM'
    },
    {
      useravatar: './assets/images/users/4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];
}
